import { DepositLimit } from "@obg/ngx.core";

import { CommonState } from "../../state";

import { DepositLimitCalculationError, DepositLimitPrediction } from "./deposit-limit-calculator.model";

export namespace DepositLimitCalculatorSelector {
	export const getPredictions = (state: CommonState): DepositLimitPrediction[] | undefined =>
		state.depositLimitCalculator.predictionsResponse?.predictions;

	export const getDepositLimits = (state: CommonState): DepositLimit[] | undefined =>
		state.depositLimitCalculator.predictionsResponse?.depositLimits;

	export const getCalculateReady = (state: CommonState): boolean => state.depositLimitCalculator.calculateReady;

	export const getCalculationError = (state: CommonState): DepositLimitCalculationError | undefined =>
		state.depositLimitCalculator.calculationError;

	export const isBusy = (state: CommonState): boolean => state.depositLimitCalculator.isBusy;
}
